import { v4 } from 'uuid';

// // Identifier functions

const getHostnameBasedDesignationId = () => {
  const hostnameInfo = window.location.hostname;
  let designationResults;

  // console.log('  identifiers getHostnameBasedDesignationId()');

  if (hostnameInfo === 'localhost') {
    designationResults = 'localhost';
  } else if (
    hostnameInfo === 'app-dev.interactive-breaks.com' ||
    hostnameInfo === 'poc-dev.interactive-breaks.com'
  ) {
    designationResults = 'dev';
  } else if (
    hostnameInfo === 'app-stage.interactive-breaks.com' ||
    hostnameInfo === 'poc-stage.interactive-breaks.com'
  ) {
    designationResults = 'stage';
  } else if (
    hostnameInfo === 'app.interactive-breaks.com' ||
    hostnameInfo === 'poc.interactive-breaks.com'
  ) {
    designationResults = 'prod';
  } else {
    designationResults = 'dev';
  }

  return designationResults;
};

const getLangId = () => {
  // console.log('  identifiers getLangId()');

  if (navigator) {
    if (navigator.languages && navigator.languages.length) {
      return navigator.languages[0];
    } else if (navigator.language) {
      return navigator.language;
    } else {
      return '';
    }
  } else {
    return '';
  }
};

const generateV4Uuid = () => {
  // console.log('  identifiers generateV4Uuid()');

  return v4();
};

const generateHyphenlessV4Uuid = () => {
  // console.log('  identifiers generateHyphenlessV4Uuid()');

  return v4().replace(/-/g, '');
};

const identifiers = {
  getHostnameBasedDesignationId,
  getLangId,
  generateV4Uuid,
  generateHyphenlessV4Uuid,
};

export default identifiers;
